import React from 'react';
import PropTypes from 'prop-types';
import lstrings from '../../../../../utils/LStrings';
import { Panel } from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor';
import TableImpuestosAutonomos from '../../../../../components/table-impuestos-autonomos/TableImpuestosAutonomos';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class PanelImpuestos extends React.Component {

    onRequestInfo = (infoKey, infoTitle) => {
        this.props.onRequestInfo(lstrings.impuestos, infoTitle);
    }

    render() {
        let titulo = <h2><i className="fa fa-bank"></i> {lstrings.impuestos}</h2>;

        return (
            <ScrollableAnchor id={'panel-impuesto'}>
                <Panel collapsible defaultExpanded header={titulo}>
                    <TableImpuestosAutonomos info={this.props.info} onRequestInfo={this.onRequestInfo} hidePanels={this.props.hidePanels}/>
                </Panel>
            </ScrollableAnchor>
        );
    }
}

PanelImpuestos.propTypes = {
    info: PropTypes.array.isRequired,
    onRequestInfo : PropTypes.func,
    hidePanels: PropTypes.any    
};

export default PanelImpuestos;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/PanelImpuestos.js